import TitleH1 from "../../Titles/title-h1";
import BookForm from "./BookForm";
import {useLocation} from "react-router-dom";

const EditBook = () => {
    const location = useLocation();
    const state = location.state;

    const book = state?.book;

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded-md shadow-md">
            <TitleH1>Update Book</TitleH1>
            <BookForm book={book}/>
        </div>
    )
}

export default EditBook;